"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Callback = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("../../hooks");
var AUTHENTICATION_IN_PROGRESS = 'AUTHENTICATION_IN_PROGRESS';
var AUTHENTICATION_SUCCEEDED = 'AUTHENTICATION_SUCCEEDED';
var AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';
;
var Callback = function Callback(props) {
  var onSuccess = props.onSuccess,
    onFailure = props.onFailure;
  var _useState = (0, _react.useState)(AUTHENTICATION_IN_PROGRESS),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    errorDescription = _useState4[0],
    setErrorDescription = _useState4[1];
  var authManager = (0, _hooks.useAuthManager)();
  (0, _react.useEffect)(function () {
    if (authManager !== null) {
      // on mount use the authManager to parse the callback URL params via handleAuthentication
      authManager.handleAuthentication().then(function (user) {
        setStatus(AUTHENTICATION_SUCCEEDED); // if onSuccess was passed, called it with the user object

        if (onSuccess) {
          onSuccess(user);
        }
      }).catch(function (err) {
        setStatus(AUTHENTICATION_FAILED);
        setErrorDescription(_lodash.default.get(err, ['message'], 'An error occurred.')); // if onFailure was passed, call it with the error

        if (onFailure) {
          onFailure(err);
        }
      });
    }
  }, []); // render output

  switch (status) {
    case AUTHENTICATION_IN_PROGRESS:
      return /*#__PURE__*/_react.default.createElement("div", null, "Logging you in...");
    case AUTHENTICATION_SUCCEEDED:
      return /*#__PURE__*/_react.default.createElement("div", null, "You have been logged in.");
    case AUTHENTICATION_FAILED:
    default:
      return /*#__PURE__*/_react.default.createElement("div", null, errorDescription);
  }
};
exports.Callback = Callback;
Callback.propTypes = {
  onSuccess: _propTypes.default.func,
  onFailure: _propTypes.default.func
};
Callback.defaultProps = {
  onSuccess: null,
  onFailure: null
};
var _default = Callback;
exports.default = _default;